import React, { useState, useEffect } from "react";
import "./../../App.css";
import Select, { components } from "react-select";

import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { bookingService, companyService, locationService, emailService } from "../../api/apiService";

function EditBooking() {
  const navigate = useNavigate();
  const location = useLocation();
  const [companies, setCompanies] = useState([]);
  const [talents, setTalents] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedTalent, setSelectedTalent] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [status, setStatus] = useState("");
  const [locations, setLocations] = useState([]);
  const [selectLocations, setSelectedLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCostCenter, setSelecedCostcenter] = useState(null);
  const [selectedCostCentertwo, setSelecedCostcentertwo] = useState(null);
  const clients = [
    { value: "PUMA", label: "PUMA" },
    { value: "Bogner", label: "Bogner" },
    { value: "TomTailor", label: "Tom Tailor" },
    { value: "video", label: "Video" },
    { value: "HFG", label: "DHFG" },
    { value: "Görtz", label: "Görtz" },
    { value: "ZEPS", label: "ZEPS" },
    { value: "ZRPDP", label: "ZRPDP" },
    { value: "BP", label: "BP" },
  ];

  const [skipCs, setSkipcs] = useState(false);

  const [title, setTitle] = useState();
  const [description, setDescription] = useState(" ");
  const [kpi, setKpi] = useState("KPI");
  const [set, setSet] = useState(
    new URLSearchParams(location.search).get("set")
  );

  const [segment, setSegment] = useState(
    new URLSearchParams(location.search).get(" ")
  );
  const [range, setRange] = useState(
    new URLSearchParams(location.search).get(" ")
  );

  const companyNameurl = new URLSearchParams(location.search).get("kunde");
  const [bookingoption, setbookingoption] = useState({
    value: new URLSearchParams(window.location.search).get("option"),
    label: new URLSearchParams(window.location.search).get("option"),
  });

  const [startTime, setStartTime] = useState();
  const [endTime, setEndTime] = useState();
  const initialClient = new URLSearchParams(location.search).get("kunde");
  const initialClientObject = clients.find(
    (client) => client.value === initialClient
  );
  const [companyNames, setCompanyNames] = useState([]);

  const fetchCompanyNames = async () => {
    try {
      const response = await companyService.getAllCompanies();
      const companyData = response.data.map(company => company.name);
      setCompanyNames(companyData);
    } catch (error) {
      console.error("Error fetching companies:", error);
      setCompanyNames([]);
    }
  };
  const companyOptions = companyNames
    .map((company) => ({
      value: company,
      label: company,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
  const [client, setClient] = useState(initialClientObject);

  const handleClientChange = (selectedOption) => {
    setClient(selectedOption);
  };

  const onmodel = [
    { value: "onmodel", label: "On Model" },
    { value: "Produkt", label: "On Produkt" },
  ];

  const options = [
    { value: "new order", label: "New order" },
    { value: "optioned", label: "Optioned" },
    { value: "talentaccepted", label: "Accepted by talent" },
    { value: "confirmed", label: "Confirmed" },
    { value: "lano", label: "Lano" },
  ];
  const position = [
    { value: "HM", label: "Hair & Make-Up" },
    { value: "AD", label: "Art Direktion" },
    { value: "foto", label: "Foto" },
    { value: "foto-assistent", label: "Foto Assist" },
    { value: "video", label: "Video" },
    { value: "digi-op", label: "Digi-OP" },
    { value: "styling", label: "Styling" },
    { value: "styling-assistent", label: "Styling Assist" },
    { value: "LOGISTIK / WARENAUFBEREITUNG", label: "LOGISTIK / WARENAUFBEREITUNG" },
    { value: "PRODUCER", label: "PRODUCER" },
    { value: "Art Buying", label: "Art Buying" }, 
    { value: "Account Management", label: "Account Management" }, 
    { value: "AI Content Production", label: "AI Content Production" }
  ];

  const bookingoptions = [
    { value: "booking", label: "booking" },
    { value: "option", label: "option" },
  ];
  const constcenter1 = [
    { id: '714', label: 'Post Outsourcing', accountNumber: '70175', value: '714' },
    { id: '715', label: 'Virtual Production-Operator', accountNumber: '70155', value: '715' },
    { id: '716', label: 'Videograf', accountNumber: '70145', value: '716' },
    { id: '717', label: 'Foto Still', accountNumber: '70110', value: '717' },
    { id: '718', label: 'Styling Still', accountNumber: '70111', value: '718' },
    { id: '719', label: 'Foto Life', accountNumber: '70120', value: '719' },
    { id: '720', label: 'Styling Life', accountNumber: '70121', value: '720' },
    { id: '721', label: 'Foto-Assistenz Life', accountNumber: '70122', value: '721' },
    { id: '722', label: 'Models', accountNumber: '70124', value: '722' },
    { id: '723', label: 'Hair & Make up', accountNumber: '70130', value: '723' },
    { id: '724', label: 'Art Direction', accountNumber: '70160', value: '724' },
    { id: '725', label: 'Post Production', accountNumber: '70170', value: '725' },
    { id: '726', label: 'Text', accountNumber: '70180', value: '726' },
    { id: '727', label: 'Sonstiges Produktion', accountNumber: '70190', value: '727' },
    { id: '728', label: 'Verpflegung Shooting', accountNumber: '70193', value: '728' },
    { id: '729', label: 'Producing', accountNumber: '70230', value: '729' },
    { id: '730', label: 'Modelbooking', accountNumber: '70240', value: '730' },
    { id: '731', label: 'Art Buying', accountNumber: '70250', value: '731' },
    { id: '732', label: 'Logistik/Warenaufbereitung', accountNumber: '70260', value: '732' },
    { id: '733', label: 'Technical Support', accountNumber: '70270', value: '733' },
    { id: '734', label: 'Setbau', accountNumber: '70280', value: '734' },
    { id: '735', label: 'Account Management', accountNumber: '70320', value: '735' },
    { id: '736', label: 'Sales/Marketing', accountNumber: '70440', value: '736' },
    { id: '737', label: 'IT/Technik', accountNumber: '70450', value: '737' },
    { id: '739', label: 'Still Operator', accountNumber: '70115', value: '739' },
    {
      id: "845",
      label: "Digital Operator",
      accountNumber: "70150",
      value: "845",
    },
    {
      id: "860",
      label: "AI Content Production",
      accountNumber: "70199",
      value: "860",
    },
  ];
  const constcenter2 = [
    { id: '738', label: 'Kunden-übergreifend / Sonstiges', accountNumber: '709005', value: '738' },
    { id: '740', label: 'S.Oliver Produktfoto', accountNumber: '700021', value: '740' },
    { id: '741', label: 'Comma Produktfoto', accountNumber: '700031', value: '741' },
    { id: '742', label: 'Liebeskind Produktfoto', accountNumber: '700041', value: '742' },
    { id: '743', label: 'Görtz Produktfoto', accountNumber: '700051', value: '743' },
    { id: '744', label: 'PUMA Produktfoto', accountNumber: '700061', value: '744' },
    { id: '745', label: 'PUMA Kampagne', accountNumber: '700062', value: '745' },
    { id: '746', label: 'TomTailor Produktfoto', accountNumber: '700071', value: '746' },
    { id: '747', label: 'TomTailor Kamagne', accountNumber: '700072', value: '747' },
    { id: '748', label: 'BonPrix Produktfoto', accountNumber: '700091', value: '748' },
    { id: '749', label: 'HFG Produktfoto', accountNumber: '700101', value: '749' },
    { id: '750', label: 'HFG Kampagne', accountNumber: '700102', value: '750' },
    { id: '751', label: 'Juvia Produktfoto', accountNumber: '700111', value: '751' },
    { id: '752', label: 'HugoBoss Produktfoto', accountNumber: '700121', value: '752' },
    { id: '753', label: 'HugoBoss Kampagne', accountNumber: '700122', value: '753' },
    { id: '754', label: 'Bogner Produktfoto', accountNumber: '700601', value: '754' },
    { id: '755', label: 'Bogner Kampagne', accountNumber: '700602', value: '755' },
    { id: '756', label: 'Heine Produktfoto', accountNumber: '700621', value: '756' },
    { id: '757', label: 'WittWeiden Produktfoto', accountNumber: '705071', value: '757' },
    { id: '758', label: 'Zalando EPS Produktfoto', accountNumber: '705141', value: '758' },
    { id: '759', label: 'Zalando EPS Kampagne', accountNumber: '705142', value: '759' },
    { id: '760', label: 'ToryBurch Produktfoto', accountNumber: '705171', value: '760' },
    { id: '761', label: 'Falke Produktfoto', accountNumber: '705181', value: '761' },
    { id: '762', label: 'Zalando RPDP Produktfoto', accountNumber: '705221', value: '762' },
    { id: '763', label: 'Sonstige Kleinkunden Produktfoto', accountNumber: '707991', value: '763' },
    { id: '766', label: 'PUMA Virtual Production', accountNumber: '700066', value: '766' },
    { id: '767', label: 'C&A Produktfoto', accountNumber: '703421', value: '767' },
    { id: '768', label: 'C&A Kampagne', accountNumber: '703422', value: '768' },
    { id: '769', label: 'C&A Virtual Production', accountNumber: '703429', value: '769' },
    { id: '773', label: 'Ziener Produktfoto', accountNumber: '705051', value: '773' },
    { id: '772', label: 'Zalando EPDP Produktfoto HH', accountNumber: '705191', value: '772' },
    {
      id: "778",
      label: "Tommy Hilfiger Produktfoto",
      accountNumber: "740411",
      value: "778",
    },
    {
      id: "847",
      label: "z PDP ACC",
      accountNumber: "705230",
      value: "847",
    },
    {
      id: "848",
      label: "Mammut PF HH ",
      accountNumber: "700551",
      value: "848",
    },
    {
      id: "856",
      label: "TB International PF HH",
      accountNumber: "700451",
      value: "856",
    },
    {
      id: "859",
      label: "Marketplace Amplifier GmbH Produktfoto HH",
      accountNumber: "700452",
      value: "859",
    },
    {
      id: "849",
      label: "DEV - AI Character Creation",
      accountNumber: "709510",
      value: "849",
    },
    {
      id: "850",
      label: "DEV - AI Character Replacement",
      accountNumber: "709512",
      value: "850",
    },
    {
      id: "852",
      label: "DEV - AI Background Replacement",
      accountNumber: "709516",
      value: "852",
    },
    {
      id: "853",
      label: "DEV - AI Background Replacement",
      accountNumber: "709518",
      value: "853",
    },
    {
      id: "854",
      label: "DEV - Bust to on-Model",
      accountNumber: "709520",
      value: "854",
    },
    {
      id: "855",
      label: "DEV - AI Content Hub",
      accountNumber: "709522",
      value: "855",
    },
    {
      id: "861",
      label: "DEV - KIND",
      accountNumber: "709524",
      value: "861",
    },
  ];
  const handleSelectCostCenter = (selectedOption) => {
    setSelecedCostcenter(selectedOption);
  };
  const handleSelectCostCentertwo = (selectedOption) => {
    setSelecedCostcentertwo(selectedOption);
  };
  const bookingId = new URLSearchParams(location.search).get("bookingId");
  // const kunde = new URLSearchParams(location.search).get('kunde');

  const customStyles = {
    dropdownIndicator: (provided, state) => ({
      ...provided,
      border: "none",
    }),
    control: (base) => ({
      ...base,
      width: "400px",
      borderColor: "black",
      borderWidth: "1px",
      boxShadow: "none",
      margin: "5px",
      borderRadius: "0px",
      color: "black", // Your color
      fontWeight: "700",
      height: "50px",
      textTransform: "uppercase",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "black", // Your color
      fontWeight: "700",
    }),
    input: (provided) => ({
      ...provided,
      color: "black", // Your color
      fontWeight: "700",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "black" : "inherit",
      "&:hover": { backgroundColor: state.isSelected ? "black" : "#f7f7f7" },
    }),
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const DropdownIndicator = (props) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <div style={{ width: "16px", margin: "0" }}>
            <svg
              version="1.1"
              id="Isolationsmodus"
              x="0px"
              y="0px"
              viewBox="0 0 322.9 257.78"
              shapeRendering="geometricPrecision"
            >
              <path
                xmlns="http://www.w3.org/2000/svg"
                d="M208.27,7.37c-4.69-4.79-11.12-7.4-17.72-7.81c-0.4-0.03-0.8-0.05-1.22-0.05l0,0h-35.34h-70.2H31.14h-4.27  C17.33-0.46,7.87,4.51,3.34,13.12C-1.19,21.65-1.3,32.3,4.19,40.47c0.85,1.3,1.74,2.56,2.6,3.82C17.3,59.73,27.77,75.2,38.27,90.64  c12.47,18.33,24.91,36.7,37.39,55.03c3.08,4.53,6.13,9.02,9.21,13.54c3.97,5.86,9.06,10.5,16.08,12.36  c6.87,1.86,14.85,0.93,20.9-2.93c3.79-2.45,6.24-5.12,8.8-8.79c8.06-11.54,15.82-23.3,23.76-34.96  c13.14-19.33,26.25-38.67,39.39-57.96c4.68-6.87,9.32-13.73,14-20.63c4.31-6.31,8.39-12.13,8.2-20.41  C215.85,18.95,213.1,12.34,208.27,7.37z"
              />
            </svg>
          </div>
        </components.DropdownIndicator>
      )
    );
  };

  const [selectedOption, setSelectedOption] = React.useState("new order");
  const [selectedPosition, setselectedPosition] = React.useState(null);
  const handleOptionChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  const handlebookingOption = (selectedOption) => {
    setbookingoption(selectedOption);
  };
  const handlesetSelect = (selectedOption) => {
    setSet(selectedOption);
  };

  const handlePostionchange = (selectedPosition) => {
    setselectedPosition(selectedPosition);
  };

  useEffect(() => {
    fetchCompanyNames();
    // Fetch companies and talents
    const fetchCompaniesAndTalents = async () => {
      try {
        const companyResponse = await companyService.getAllCompanies();
        const companyData = companyResponse.data.map((company) => ({
          value: company.id,
          label: company.name,
        }));

        if (companyNameurl) {
          const matchingCompany = companyData.find(
            (company) => company.label === companyNameurl
          );
          setSelectedCompany(matchingCompany);
        }

        setCompanies(companyData);
        setTalents([]); // We'll handle talents separately if needed

        setLoading(false);
      } catch (error) {
        console.error("Error fetching companies and talents:", error);
        setLoading(false);
      }
    };
    const fetchBookingDetail = async (bookingId) => {
      try {
        console.log("Fetching booking with ID:", bookingId);
        const response = await bookingService.getBookingById(bookingId);
        
        if (!response.data) {
          console.log("No booking found with ID:", bookingId);
          return;
        }
        
        const booking = response.data;
        console.log("Booking data retrieved from API:", booking);

        // Handle client - could be object or string
        if (typeof booking.client === 'object' && booking.client !== null) {
          setClient(booking.client);
        } else {
          setClient({ value: booking.client, label: booking.client });
        }

        // Handle position - could be object or string
        if (typeof booking.position === 'object' && booking.position !== null) {
          setselectedPosition(booking.position);
        } else {
          setselectedPosition({ value: booking.position, label: booking.position });
        }

        setStartTime(booking.start_time || booking.startTime || '');
        setEndTime(booking.end_time || booking.endTime || '');
        
        // Handle location - could be object or string
        let locationValue = '';
        if (typeof booking.location === 'object' && booking.location !== null) {
          locationValue = booking.location.name || booking.location.short || '';
          setTitle(locationValue);
        } else {
          locationValue = booking.location || '';
          setTitle(locationValue);
        }

        // Handle cost centers - could be objects or strings
        if (typeof booking.cost_center1 === 'object' && booking.cost_center1 !== null) {
          setSelecedCostcenter(booking.cost_center1);
        } else {
          setSelecedCostcenter(booking.costcenter1 || null);
        }

        if (typeof booking.cost_center2 === 'object' && booking.cost_center2 !== null) {
          setSelecedCostcentertwo(booking.cost_center2);
        } else {
          setSelecedCostcentertwo(booking.costcenter2 || null);
        }

        if (booking.sonstige_info || booking.sinfo) {
          setDescription(booking.sonstige_info || booking.sinfo || '');
        }

        // Handle KPI - ensure it's a string or number
        const kpiValue = booking.kpi;
        if (typeof kpiValue === 'object' && kpiValue !== null) {
          console.warn('KPI is an object, using empty string:', kpiValue);
          setKpi('');
        } else {
          setKpi(kpiValue || '');
        }

        // Handle set - could be object or string
        if (typeof booking.set === 'object' && booking.set !== null) {
          setSet(booking.set);
        } else {
          setSet({ value: booking.set, label: booking.set });
        }

        if (booking.segment) {
          setSegment(booking.segment);
        }
        if (booking.model) {
          setRange(booking.model);
        }

        const start = new Date(booking.start_date || booking.startDate);
        const formattedsDate = formatDate(start);
        const end = new Date(booking.end_date || booking.endDate);
        const formattedeDate = formatDate(end);

        setStartDate(formattedsDate);
        setbookingoption({ value: booking.option, label: booking.option });
        
        // Handle location for select dropdown
        if (typeof booking.location === 'object' && booking.location !== null) {
          setSelectedLocations({
            value: booking.location.id || booking.location.short || booking.location.name,
            label: booking.location.name || booking.location.short || ''
          });
        } else {
          setSelectedLocations({
            value: booking.location,
            label: booking.location
          });
        }
        setEndDate(formattedeDate);
        console.log("Option is: " + booking.option);
      } catch (error) {
        console.error("Error fetching booking details:", error);
      }
    };
    fetchBookingDetail(new URLSearchParams(location.search).get("bookingId"));
    fetchCompaniesAndTalents();
  }, []);

  const handleCompanyChange = (selectedOption) => {
    setSelectedCompany(selectedOption);
  };
  const fetchlocations = async () => {
    try {
      const response = await locationService.getAllLocations(1, 1000);
      const locationData = response.data.map((location) => location.short);
      setLocations(locationData);
    } catch (error) {
      console.error("Error fetching locations:", error);
      setLocations([]);
    }
  };
  const locationOptions = locations
    .map((locations) => ({
      value: locations,
      label: locations,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  const handleTalentChange = (selectedOption) => {
    setSelectedTalent(selectedOption);
  };
  const createmail = async (newValue) => {
    const emailContent = `
      <h2>Booking Updated</h2>
      <p>An order has been updated with the following details:</p>
      <ul>
        <li><strong>Title:</strong> ${newValue.title}</li>
        <li><strong>Start Date:</strong> ${newValue.startDate}</li>
        <li><strong>End Date:</strong> ${newValue.endDate}</li>
        <li><strong>Position:</strong> ${newValue.position?.label || newValue.position}</li>
        <li><strong>Client:</strong> ${newValue.client?.label || newValue.client}</li>
        <li><strong>KPI:</strong> ${newValue.kpi}</li>
        <li><strong>Set:</strong> ${newValue.set}</li>
        <li><strong>Option:</strong> ${newValue.option}</li>
      </ul>
      <p><strong>Propose talents to this:</strong><br>
      <a href="https://app.set-cast.com/admin/propose?bookingId=${newValue.bookingID}">https://app.set-cast.com/admin/propose?bookingId=${newValue.bookingID}</a></p>
      <p><strong>Manage All new Orders:</strong><br>
      <a href="https://app.set-cast.com/admin/allnewbookings">https://app.set-cast.com/admin/allnewbookings</a></p>
    `;

    const emailData = {
      to_email: "booking@set-cast.com, talent@mondula.com",
      cc: localStorage.getItem("userEmail"),
      subject: "Booking Updated - Set-Cast",
      content: emailContent,
      template_data: {
        title: newValue.title,
        start_date: newValue.startDate,
        end_date: newValue.endDate,
        position: newValue.position?.label || newValue.position,
        client: newValue.client?.label || newValue.client,
        kpi: newValue.kpi,
        set: newValue.set,
        option: newValue.option,
        booking_id: newValue.bookingID
      }
    };

    try {
      await emailService.sendEmail(emailData);
      console.log("Update notification email sent successfully");
    } catch (error) {
      console.error("Error sending update notification email:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if it's a new booking or an update
    if (bookingId) {
      // Update existing booking
      try {
        const updateData = {
          start_date: startDate,
          end_date: startDate,
          start_time: startTime,
          end_time: endTime,
          title: title,
          kpi: kpi,
          set: set?.label || set,
          sonstige_info: description,
          position: selectedPosition,
          client: client,
          segment: segment,
          model: range,
          cost_center1: selectedCostCenter,
          cost_center2: selectedCostCentertwo,
          option: bookingoption.value,
          location: selectLocations?.value || selectLocations,
          updated_by: localStorage.getItem("userEmail")
        };

        await bookingService.updateBooking(bookingId, updateData);

        const newValue = {
          startDate: startDate,
          endDate: startDate,
          startTime: startTime,
          endTime: endTime,
          sinfo: description,
          kpi: kpi,
          set: set?.label || set,
          position: selectedPosition,
          client: client,
          segment: segment,
          model: range,
          costcenter1: selectedCostCenter,
          costcenter2: selectedCostCentertwo,
          option: bookingoption.value,
          bookingID: bookingId,
          createdBy: localStorage.getItem("userEmail"),
          location: selectLocations?.value || selectLocations,
          title: title
        };

        alert("Booking updated successfully.");
        // Uncomment the line below if you want to send email notifications
        // await createmail(newValue);

        window.location.href = "/admin/booking";
      } catch (error) {
        console.error("Error updating booking: ", error);
        alert("Failed to update booking. Please try again.");
      }
    }
  };

  useEffect(() => {
    fetchlocations();
    if (startDate === "") {
      document.getElementById("start-date").placeholder = "Start Date";
    }
  }, [startDate, endDate]);

  return (
    <div class="content-wrapper page">
        <h1 className="h1">{"Update Booking"}</h1>
        <form
          onSubmit={handleSubmit}
          style={{
            marginTop: "40px",
            maxWidth: "500px",
          }}
        >
          {bookingId ? (
            // If bookingId exists, render your 'editing' JSX here, example:
            <div style={{ width: "100%", textTransform: "uppercase" }}></div>
          ) : (
            <></>
          )}

          <Select
            components={{ DropdownIndicator }}
            options={companyOptions}
            onChange={handleClientChange}
            placeholder="Client"
            value={client}
            styles={customStyles}
          />

          <Select
            components={{ DropdownIndicator }}
            options={position}
            onChange={handlePostionchange}
            placeholder="Position"
            value={selectedPosition}
            styles={customStyles}
          />

          <Select
            value={selectLocations}
            onChange={setSelectedLocations}
            options={locationOptions}
            isClearable
            placeholder="Locations"
            styles={customStyles}
          />
          <input
            className="inputtext"
            type="text"
            value={description || ""}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Sonstige Info"
          />
          <input
            className="inputtext"
            type="text"
            value={kpi}
            onChange={(e) => setKpi(e.target.value)}
            placeholder="KPI"
          />

          <Select
            components={{ DropdownIndicator }}
            options={onmodel}
            required
            onChange={handlesetSelect}
            placeholder="Set"
            value={set}
            styles={customStyles}
          />
            <div>

                      <Select
                        components={{ DropdownIndicator }}
                        options={constcenter1}
                        onChange={handleSelectCostCenter}
                        placeholder="CostCenter 1"
                        value={selectedCostCenter}
                        styles={customStyles}
                        required
                      />
                    </div>
                    <div>
                       
                      <Select
                        components={{ DropdownIndicator }}
                        options={constcenter2}
                        onChange={handleSelectCostCentertwo}
                        placeholder="CostCenter 2"
                        value={selectedCostCentertwo}
                        styles={customStyles}
                        required
                      />
                    </div>

          <input
            className="inputtext"
            type="text"
            value={range}
            onChange={(e) => setRange(e.target.value)}
            placeholder="Model"
          />
          <input
            className="inputtext"
            type="text"
            value={startTime}
            onChange={(e) => setStartTime(e.target.value)}
            placeholder="Start Time"
          />
          <input
            className="inputtext"
            type="text"
            value={endTime}
            onChange={(e) => setEndTime(e.target.value)}
            placeholder="End Time"
          />

          <div style={{ display: "inline" }}>
            <div className="date-input-wrapper">
              <input
                className="inputdate"
                style={{ width: "500px" }}
                id="start-date"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
              <svg className="custom-icon" viewBox="0 0 500 500">
                <path d="M477.5,39h-105V21.5c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5  c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5c0-6.25-3.34-12.03-8.75-15.16  s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-105c-4.64,0-9.09,1.84-12.38,5.12S5,51.86,5,56.5v420c0,4.64,1.84,9.09,5.12,12.38  S17.86,494,22.5,494h455c4.64,0,9.09-1.84,12.38-5.12s5.12-7.73,5.12-12.38v-420c0-4.64-1.84-9.09-5.12-12.38S482.14,39,477.5,39z   M127.5,74v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16  s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74H460v70  H40V74H127.5z M40,459V179h420v280H40z M302.5,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,244.36,302.5,249z M425,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,244.36,425,249z M180,249  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5  s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,244.36,180,249z M302.5,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,314.36,302.5,319z M425,319c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,314.36,425,319z M180,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S180,314.36,180,319z M302.5,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S302.5,384.36,302.5,389z M425,389  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70  c4.64,0,9.09,1.84,12.38,5.12S425,384.36,425,389z M180,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,384.36,180,389z" />
              </svg>
            </div>

            {/*  <div className="date-input-wrapper">
              <input className='inputdate' id="end-date" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)}  placeholder='END' />
              <svg className="custom-icon" viewBox="0 0 500 500" >
                <path d="M477.5,39h-105V21.5c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5  c0-6.25-3.34-12.03-8.75-15.16s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-70V21.5c0-6.25-3.34-12.03-8.75-15.16  s-12.09-3.12-17.5,0s-8.75,8.9-8.75,15.16V39h-105c-4.64,0-9.09,1.84-12.38,5.12S5,51.86,5,56.5v420c0,4.64,1.84,9.09,5.12,12.38  S17.86,494,22.5,494h455c4.64,0,9.09-1.84,12.38-5.12s5.12-7.73,5.12-12.38v-420c0-4.64-1.84-9.09-5.12-12.38S482.14,39,477.5,39z   M127.5,74v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16  s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74h70v17.5c0,6.25,3.34,12.03,8.75,15.16s12.09,3.12,17.5,0s8.75-8.9,8.75-15.16V74H460v70  H40V74H127.5z M40,459V179h420v280H40z M302.5,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,244.36,302.5,249z M425,249c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  c-3.12-5.41-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,244.36,425,249z M180,249  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75c-3.12-5.41-3.12-12.09,0-17.5  s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,244.36,180,249z M302.5,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S302.5,314.36,302.5,319z M425,319c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S425,314.36,425,319z M180,319c0,4.64-1.84,9.09-5.12,12.38  s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12  S180,314.36,180,319z M302.5,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75  s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S302.5,384.36,302.5,389z M425,389  c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70  c4.64,0,9.09,1.84,12.38,5.12S425,384.36,425,389z M180,389c0,4.64-1.84,9.09-5.12,12.38s-7.73,5.12-12.38,5.12h-70  c-6.25,0-12.03-3.34-15.16-8.75s-3.12-12.09,0-17.5s8.9-8.75,15.16-8.75h70c4.64,0,9.09,1.84,12.38,5.12S180,384.36,180,389z" />
              </svg>
            </div>
          */}
          </div>

          <Select
            components={{ DropdownIndicator }}
            options={bookingoptions}
            onChange={handlebookingOption}
            placeholder="Choose an Option"
            value={bookingoption}
            styles={customStyles}
          />

          <div className="button-wrapper">
            <button
              style={{ marginTop: "20px" }}
              className="big-button"
              type="submit"
            >

              
              {bookingId ? "Update Booking" : "New order"}
            </button>
          </div>
        </form>
    </div>
  );
}

export default EditBooking;
